import { render, staticRenderFns } from "./confirm-account.vue?vue&type=template&id=f37a4464&"
import script from "./confirm-account.vue?vue&type=script&lang=js&"
export * from "./confirm-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports